import { cn } from "@do/ui/lib/utils";
import { useMemo } from "react";
import { useChat } from "../../providers/chat-provider";

export const HeaderTitles = ({ srOnly = false }: { srOnly?: boolean }) => {
  const { chatbotParams, selectedLocale, defaultLocale } = useChat();

  const title = useMemo(() => {
    return selectedLocale?.title || defaultLocale?.title || chatbotParams.title;
  }, [selectedLocale, defaultLocale, chatbotParams.title]);

  const subTitle = useMemo(() => {
    return selectedLocale?.subTitle || defaultLocale?.subTitle || chatbotParams.subTitle;
  }, [selectedLocale, defaultLocale, chatbotParams.subTitle]);

  // The full logo already shows the name. The title stays for assistive technologies (the chat is
  // labelled by it), without a wrapper so it takes no room, nor a gap, next to the logo.
  if (srOnly) {
    return (
      <h1 id="header-title" className="sr-only">
        {title}
      </h1>
    );
  }

  return (
    <div id="header-titles" className="flex flex-col overflow-hidden">
      <h1
        id="header-title"
        className={cn(
          "text-(--header-title-color)/(--header-title-color-opacity) text-(length:--header-title-font-size)",
          "font-(--header-title-font-weight)! font-(family-name:--header-title-font-family)",
          "leading-(--header-title-line-height)",
          "truncate"
        )}
      >
        {title}
      </h1>
      {subTitle && (
        <p
          id="header-subtitle"
          className={cn(
            "text-(--header-subtitle-color)/(--header-subtitle-color-opacity) text-(length:--header-subtitle-font-size)",
            "font-(--header-subtitle-font-weight)! font-(family-name:--header-subtitle-font-family)",
            "leading-(--header-subtitle-line-height)",
            "truncate"
          )}
        >
          {subTitle}
        </p>
      )}
    </div>
  );
};
